import {observer} from 'mobx-react';
import {Dispatch, SetStateAction} from 'react';
import {CompetitorsTable} from './CompetitorsTable';
import {useStore} from '@/store/root-store';
import {CompetitorsDetail} from './CompetitorsDetail';

interface Props {
  isSubscriber: boolean;
  activeKw: string;
  setActiveKw: Dispatch<SetStateAction <string>>;
  setCompetitors: (value: any) => void;
  competitors: any;
  filteredCompetitorsData: any;
  setFilteredCompetitorsData: (value: any) => void;
  schemaTypesList: any;
  setSchemaTypesList: (value: any) => void;
  allSchemasCount: number;
  setAllSchemasCount: (value: number) => void;
  nullCount: number;
  setNullCount: (value: number) => void;
  selectedSchema: any;
  setSelectedSchema: (value: any) => void;
}

export const CompetitorsDrawerTab = observer(({
  isSubscriber,
  activeKw,
  setActiveKw,
  setCompetitors,
  competitors,
  filteredCompetitorsData,
  setFilteredCompetitorsData,
  schemaTypesList,
  setSchemaTypesList,
  allSchemasCount,
  setAllSchemasCount,
  nullCount,
  setNullCount,
  selectedSchema,
  setSelectedSchema}: Props) => {
  const {contentOptimizer: {currentPage}} = useStore('');
  const {contentOptimizer: {
    currentPage: {
      showCompetitorTermsTableDetail,
    }}} = useStore('');

  return showCompetitorTermsTableDetail ? <CompetitorsDetail/> : <CompetitorsTable
    activeKw={activeKw}
    setActiveKw={setActiveKw}
    store={currentPage}
    isSubscriber={isSubscriber}
    setCompetitors={setCompetitors}
    competitors={competitors}
    filteredCompetitorsData={filteredCompetitorsData}
    setFilteredCompetitorsData={setFilteredCompetitorsData}
    schemaTypesList={schemaTypesList}
    setSchemaTypesList={setSchemaTypesList}
    allSchemasCount={allSchemasCount}
    setAllSchemasCount={setAllSchemasCount}
    nullCount={nullCount}
    setNullCount={setNullCount}
    selectedSchema={selectedSchema}
    setSelectedSchema={setSelectedSchema} />;
});
